import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  registrosTPV: '',
  loading: false,
  error: '',
  errorDescription: '',
  totalRegistros: 0
}

// getters
const getters = {
  getlistTpvData: state => state.registrosTPV,
  getTotalTpvRegistros: state => state.totalRegistros
}

// actions
const actions = {
  async listTpv ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomF = ''
      if (params.codcom !== undefined) {
        codcomF = params.codcom
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcomF: codcomF
          }
        }
      })
      commit('LISTTPVSREQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listTpv, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LISTTPVS_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            return response.data.runServiceResponse.return

          case 210:
            return []

          case 102:
            return []

          case 200:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTTPVSREQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTTPVS_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTTPVS_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.registrosTPV = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'LISTTPVS_REQUEST_FAILED' (state, payload) {
    var error
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión Expirada'
    } else if (payload.retorno === 102) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.registrosTPV = ''
    return error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
